<template>
  <div>
    <div class="title">
      <div>ebs快照</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticBlockStoreSnapshotResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticBlockStoreSnapshotResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <elastic-block-store-snapshot-resource-search
      ref="child"
    ></elastic-block-store-snapshot-resource-search>
    <table-elastic-block-store-snapshot-resource></table-elastic-block-store-snapshot-resource>
  </div>
</template>

<script>
import ElasticBlockStoreSnapshotResourceSearch from "../ebs_snapshot/ElasticBlockStoreSnapshotResourceSearch";
import TableElasticBlockStoreSnapshotResource from "../ebs_snapshot/TableElasticBlockStoreSnapshotResource";

export default {
  name: "ElasticBlockStoreSnapshotResource",
  components: {
    ElasticBlockStoreSnapshotResourceSearch,
    TableElasticBlockStoreSnapshotResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountIds,
          resourceManagement: 19
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSSnapshot({
          companyId: this.$refs.child.companyId,
          accountName: this.$refs.child.accountName,
          accountIdList: this.$refs.child.accountIds,
          snapshotId: this.$refs.child.snapshotId
        })
        .then(res => {
          let fileName = "ebs快照.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ebs_snapshot/ElasticBlockStoreSnapshotResource.vue